import React from "react";
import "./PubCard.scss";

export default function TalkCard({pubDetails}) {
  return (
    <div>
      <div className="container">
        <div
          className={
            pubDetails.isDark ? "dark-rectangle rectangle" : "rectangle"
          }
        >
          <div className="diagonal-fill"></div>
          <div className="pub-card-title">{pubDetails.title}</div>
          <p className="pub-card-subtitle">{pubDetails.subtitle}</p>

          <div className="card-footer-button-div">
            <a href={pubDetails.website_url} target="_" className="pub-button">
              Website
            </a>
            <a href={pubDetails.paper_url} target="_" className="pub-button">
              Paper
            </a>
            <a href={pubDetails.github_url} target="_" className="pub-button">
              Code
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
